module.exports = __webpack_public_path__ + "static/media/video.1a224377.ogv";